/**
 * Sparkline: mini gráfica de tendencia en SVG puro.
 * Sin librerías: se dibuja una vez, pesa nada y cabe en una tarjeta de KPI.
 */
export const Sparkline = ({ data = [], stroke = 'hsl(var(--primary))', fill = true, height = 34, className = '' }) => {
  const serie = (data || []).filter((n) => Number.isFinite(n));
  if (serie.length < 2) return null;

  const w = 100;
  const h = 100;
  const max = Math.max(...serie);
  const min = Math.min(...serie);
  const rango = max - min || 1;

  const puntos = serie.map((v, i) => {
    const x = (i / (serie.length - 1)) * w;
    const y = h - ((v - min) / rango) * (h - 12) - 6;
    return [x, y];
  });

  const linea = puntos.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(2)},${y.toFixed(2)}`).join(' ');
  const area = `${linea} L${w},${h} L0,${h} Z`;
  const id = `spark-${String(stroke).replace(/[^a-z0-9]/gi, '')}-${serie.length}`;
  const ultimo = puntos[puntos.length - 1];

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="none"
      className={className}
      style={{ height }}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={stroke} stopOpacity="0.28" />
          <stop offset="100%" stopColor={stroke} stopOpacity="0" />
        </linearGradient>
      </defs>
      {fill && <path d={area} fill={`url(#${id})`} />}
      <path d={linea} fill="none" stroke={stroke} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
      <circle cx={ultimo[0]} cy={ultimo[1]} r="3" fill={stroke} />
    </svg>
  );
};

export default Sparkline;
